<template>
    <div>
        <div class="message-tips">
            <svg-icon name="common.tip-solid" />
            系统操作为平台内置的能力，已经抹平了跨平台差异，可以在多种终端使用
        </div>
        <div class="content-container">
            <hc-table :data="operationList">
                <hc-table-column label="操作名称" width="200px" prop="name" />
                <hc-table-column label="操作说明" prop="remark" />
                <hc-table-column label="适用场景" prop="scene" />
                <hc-table-column label="使用要求" prop="ask">
                    <template slot-scope="{ row }">
                        <div class="wrap-column">
                            {{ row.ask }}
                        </div>
                    </template>
                </hc-table-column>
            </hc-table>
        </div>
    </div>
</template>
<script>
import { SystemOperationList } from './const'

export default {
    name: 'SysTemOperation',
    data() {
        return {
            operationList: Object.freeze(SystemOperationList),
        }
    },
}
</script>
<style lang="less" scoped>
.message-tips {
    display: flex;
    font-size: 12px;
    color: #507AFE;
    line-height: 20px;
    border-radius: 4px;
    padding: 10px 16px;
    margin-bottom: 16px;
    align-items: center;
    background: rgba(80,122,254,0.1);
    .svg-icon {
        font-size: 16px;
        color:#507AFE;
        margin-right: 8px;
    }
}
/deep/ .hc-table {
    .hc-table__row {
        height: 47px;
    }
    .wrap-column {
        text-indent: -3px;
        white-space: pre-wrap;
    }
}
</style>
